import React from 'react'
// layers
import ActivityBL from 'containers/Activities/layers/BL/Activity'
// components
import Activity from 'components/Modals/PlanItems/components/ActivitiesList/components/Activities'

const ActivityContainer = props => (
  <ActivityBL {...props}>
    <Activity />
  </ActivityBL>
)

export default ActivityContainer
